import * as React from 'react'
import {FooterScreen,Header} from "../shared"

export const TechnicalScreen = () => {
    return (
        <>
            <Header />
            <div className="fables-header fables-after-overlay bg-rules">
                <div className="container">
                    <h2 className="fables-page-title fables-second-border-color wow fadeInLeft" data-wow-duration="1.5s">Technical Architecture & Capabilities</h2>
                </div>
            </div>

            <div className="container my-5">
                <div className="row">
                    <div className="col-12">
                        <p className="fables-forth-text-color">This section captures the detailed technical capabilities that support our execution model. High-level executives will find outcomes and risk controls here; technical teams will find architecture and tooling details below.</p>
                    </div>
                </div>

                <div className="row my-4">
                    <div className="col-12 col-md-6">
                        <h4 className="font-18 semi-font">Data Engineering</h4>
                        <ul className="fables-forth-text-color">
                            <li>Functional specifications and data architecture: data models, ingestion patterns, and governance.</li>
                            <li>ETL/ELT pipelines, data cataloging, and lineage for auditability and regulatory traceability.</li>
                            <li>Data storage and processing strategies across cloud, on-premise, and hybrid deployments.</li>
                        </ul>
                    </div>
                    <div className="col-12 col-md-6">
                        <h4 className="font-18 semi-font">Engineering & Architecture</h4>
                        <ul className="fables-forth-text-color">
                            <li>Secure, sovereign infrastructure design with identity, encryption, and network segmentation.</li>
                            <li>API design, microservices, containers, and CI/CD patterns for regulated environments.</li>
                            <li>Hardware & cloud orchestration: support for on-prem GPU racks, cloud GPU fleets, and hybrid models (NVIDIA DGX, cloud GPUs).</li>
                        </ul>
                    </div>
                </div>

                <div className="row my-4">
                    <div className="col-12 col-md-6">
                        <h4 className="font-18 semi-font">Data Management</h4>
                        <ul className="fables-forth-text-color">
                            <li>Data quality, monitoring, and access controls to satisfy QMS and regulatory audits.</li>
                            <li>Graph and relational databases, feature stores, and secure data lakes for model reproducibility.</li>
                            <li>Provenance, anonymization, and consent tracking where required.</li>
                        </ul>
                    </div>
                    <div className="col-12 col-md-6">
                        <h4 className="font-18 semi-font">Model Development</h4>
                        <ul className="fables-forth-text-color">
                            <li>Exploratory data analysis, model training, tuning, and benchmarking.</li>
                            <li>Tooling and frameworks: PyTorch, TensorFlow, scikit-learn, and orchestration around MLFlow or Sagemaker.</li>
                            <li>Reproducibility, test harnesses, and benchmarking against held-out clinical datasets where applicable.</li>
                        </ul>
                    </div>
                </div>

                <div className="row my-4">
                    <div className="col-12 col-md-6">
                        <h4 className="font-18 semi-font">MLOps & Deployment</h4>
                        <ul className="fables-forth-text-color">
                            <li>Production CI/CD for models, automated validation, and post-deployment monitoring.</li>
                            <li>Serving and inferencing options: NVIDIA Triton, serverless inferencing, or container-based deployments for latency-sensitive workloads.</li>
                            <li>Model governance: versioning, drift detection, challenger strategies, and roll-back controls.</li>
                        </ul>
                    </div>
                    <div className="col-12 col-md-6">
                        <h4 className="font-18 semi-font">DevOps & HPC Enablement</h4>
                        <ul className="fables-forth-text-color">
                            <li>Cluster orchestration, GPU scheduling, and cost-aware resource management.</li>
                            <li>High-performance data pipelines and batch/stream processing for clinical and operational data.</li>
                            <li>Security hardening, compliance controls, and enterprise monitoring.</li>
                        </ul>
                    </div>
                </div>

                <div className="row my-5">
                    <div className="col-12">
                        <h4 className="font-18 semi-font">How this supports Regulation & Commercialization</h4>
                        <p className="fables-forth-text-color">These technical building blocks are designed to map directly to regulatory artifacts (SaMD documentation, QMS records) and commercial requirements (scalability, repeatability, and evidence generation). Detailed architecture diagrams and runbooks are available on request for portfolio or partner due diligence.</p>
                    </div>
                </div>
            </div>

            <FooterScreen />
        </>
    )
}

export default TechnicalScreen
